module.exports = __webpack_public_path__ + "images/dj-logo-b70a664628960eb1bfa216b3387d5e92.png";